// extracted by mini-css-extract-plugin
export default {"titleFlow":"index_titleFlow_0OrTo"};